authService.$inject = [
  '$ngRedux',
  '$http',
  '$state',
  '$window',
  '$timeout',
  '$cookies',
  'authActions',
  'APP',
  '$uibModal',
  '$stateParams',
  '$rootScope'
];

export default function authService($ngRedux, $http, $state, $window,
  $timeout, $cookies, authActions, APP, $uibModal, $stateParams, $rootScope) {
  
  let service = {
    nonLoggedInOnly,
    isAuthenticated,
    isMobileOnly,
    getStoreDetail,
    registerLogin,
    logout,
    registerUser,
    registerStoreUser,
    verifyCustomerEmail,
    sendEmailToStore,
    findCustomerInfo,
    forgotPassword,
    resetPassword,
    changePassword,
    activate,
    oTPactivate,
    activateUser,
    resendEmail,
    getUserProfile,
    getGuestUserProfile,
    updateUserProfile,
    isGuestLogin,
    showLoginPopUp,
    addtoGuestCart,
    updatetoGuestCart,
    removetoGuestCart,
    getGuestCart,
    doGuestLogin,
    doGuestLogout,
    removeGuestCart,
    getGuestStoreDetail,
    isLoggedIn,
    addToSubscriptionCart,
    getSubscribedItems,
    setSubscribedItems,
    setSubscribedInfo,
    getSubscribedInfo,
    resetSubscriptionCart,
    cancelSubscriptionfromEmail,
    subscriptionmodifyId,
    modifySubscripitonfromEmail,
    getSubscriptionId,
    saveSubscriptionLocalState,
    getSubscriptionLocalState,
    getCountries,
    isMobileDevice,
    isMobileLandscapeDevice,
    isBrowseUrl,
    getStoresbyZipcode,
    getAllStores,
    changeStore,
    setAllStores,
    getDscImage,
    getFreeShippingFromStore,
    validatingPoBoxAddress,
    addGuestUser,
    getGuestUser,
    removeGuestUser,
    saveGuestUser,
    getGuestUserById,
    createGuestCart,
    getStore,
    avalaraResolveAddress,
    openPopUpForAddressResolve,
    isValidatedAddressSame,
    setAgreedCookie,
    getPwrKeys,
    getBBDetails,
    getStoreByStoreName,
    togglePassword,
    removeRemainderSession,
    getBaseShippingCharge,
    printCustomerGenericLogs
  };
  return service;

  function base() {
    return APP.AUTH.AUTH_URL;
  }

  function baseOrderConstants() {
    return APP.ORDER;
  }

  function nonLoggedInOnly() {
    return $timeout(() => {
      let oauth = null;
      try {
        sessionStorage.setItem('dummy', 'value');
        oauth = sessionStorage.getItem('oauth');
      }
      catch (e) {
        oauth = $cookies.get('oauth');
      }
      if (oauth) {
        $state.go('home');
      }
    });
  }
  function isLoggedIn() {

    let oauth = null;
    try {
      sessionStorage.setItem('dummy', 'value');
      oauth = sessionStorage.getItem('oauth');
    }
    catch (e) {
      oauth = $cookies.get('oauth');
    }
    if (oauth) {
      return true;
    }
    return false;

  }
  function isBrowseUrl() {
    return $timeout(() => {
      $state.go('browse-sub-category', { 'categoryId': $stateParams.categoryId });
    }, 200);
  }
  function isAuthenticated() {
    return $timeout(() => {
      let oauth = null;
      let browseAsGuest = null;

      try {
        sessionStorage.setItem('dummy', 'value');
        oauth = sessionStorage.getItem('oauth');
        browseAsGuest = sessionStorage.getItem('browseAsGuest');
      }
      catch (e) {
        oauth = $cookies.get('oauth');
        browseAsGuest = $cookies.get('browseAsGuest');
      }
      if (!oauth && !browseAsGuest) {

        //  $state.go('login');
      }
    }, 1000);
  }
  
  function addtoGuestCart(cart) {
    if (cart) {
      try {
        let cartList = getGuestCart();
        if (cartList && cartList.length) {
          let index = cartList.findIndex(data => data.itemId === cart.itemId);
          if (~index) {
            cartList[index].quantity = cartList[index].quantity + cart.quantity;
          } else {
            cartList.push(cart);
          }
        } else {
          cartList = [cart];
        }
        $ngRedux.dispatch(authActions.setGuestCart(cartList));
        sessionStorage.setItem('guestCart', JSON.stringify(cartList));
        // $cookies.put('guestCart', JSON.stringify(cartList));
      }
      catch (e) {
        $cookies.put('guestCart', JSON.stringify(cart));
      }
    }
  }
  function updatetoGuestCart(cartList) {
    if (cartList) {
      try {
        $ngRedux.dispatch(authActions.setGuestCart(cartList));
        sessionStorage.setItem('guestCart', JSON.stringify(cartList));
        // $cookies.put('guestCart', JSON.stringify(cartList));
      }
      catch (e) {
        $cookies.put('guestCart', JSON.stringify(cartList));
      }
    }
  }
  function removetoGuestCart(cartItemId) {
    if (cartItemId) {
      let cartList = getGuestCart();
      try {
        if (cartList && cartList.length) {
          cartList = cartList.filter(data => data.itemId !== cartItemId);
        }
        $ngRedux.dispatch(authActions.setGuestCart(cartList));
        sessionStorage.setItem('guestCart', JSON.stringify(cartList));
        // $cookies.put('guestCart', JSON.stringify(cartList));
      }
      catch (e) {
        $cookies.put('guestCart', JSON.stringify(cartList));
      }
    }
  }
  function getGuestCart() {
    let guestCartStr = null;
    try {
      sessionStorage.setItem('dummy', 'value');
      guestCartStr = sessionStorage.getItem('guestCart');
      if (!guestCartStr && !sessionStorage.getItem('guestOrderCheckedOut')) {
        if (sessionStorage.getItem('storeId') == $cookies.get('storeId')) {
          guestCartStr = $cookies.get('guestCart');
        }
      }
    }
    catch (e) {

      guestCartStr = $cookies.get('guestCart');
    }
    if (guestCartStr) {
      $ngRedux.dispatch(authActions.setGuestCart(JSON.parse(guestCartStr)));
      return JSON.parse(guestCartStr);
    }
    return guestCartStr;
  }
  function doGuestLogin(store) {
    try {

      if (sessionStorage.getItem('storeId') != store.storeId) {
        removeGuestCart();
      }

      sessionStorage.setItem('browseAsGuest', 'true');
      sessionStorage.setItem('guestStoreName', store.storeName);
      sessionStorage.setItem('storeId', store.storeId);
      // Set Cookies 
      // $cookies.put('browseAsGuest', 'true');
      // $cookies.put('guestStoreName', store.storeName);
      // $cookies.put('storeId', store.storeId);
    }
    catch (e) {
      $cookies.put('browseAsGuest', 'true');
      $cookies.put('guestStoreName', store.storeName);
      $cookies.put('storeId', store.storeId);
    }
    $rootScope.$emit('onGuestLogin');
  }
  function removeGuestCart() {
    try {
      $ngRedux.dispatch(authActions.setGuestCart([]));
      sessionStorage.removeItem('guestCart');
      sessionStorage.removeItem('GuestCartRequest');
      sessionStorage.removeItem('guestUserDetails');
      sessionStorage.removeItem('curbSideDetails');
      sessionStorage.removeItem('discountCoupon');
      $cookies.remove('guestCart');
      $cookies.remove('GuestCartRequest');
    }
    catch (e) {
      $cookies.remove('guestCart');
      $cookies.remove('GuestCartRequest');
    }
  }
  function doGuestLogout() {
    try {
      $ngRedux.dispatch(authActions.setGuestCart([]));
      sessionStorage.removeItem('browseAsGuest');
      sessionStorage.removeItem('guestStoreName');
      sessionStorage.removeItem('storeId');
      sessionStorage.removeItem('guestoauth');
      sessionStorage.removeItem('isGuestUserLoggedIn');
      $cookies.remove('browseAsGuest');
      $cookies.remove('guestStoreName');
      $cookies.remove('storeId');
      removeGuestUser();
      removeRemainderSession();
    }
    catch (e) {
      $cookies.remove('browseAsGuest');
      $cookies.remove('guestStoreName');
      $cookies.remove('storeId');
      removeGuestUser();
      removeRemainderSession();
    }
  }
  function isGuestLogin() {
    let isGuest = false;
    if (this.isLoggedIn()) {
      this.doGuestLogout();
      return false;
    }
    try {
      sessionStorage.setItem('dummy', 'value');
      isGuest = sessionStorage.getItem('browseAsGuest');
    }
    catch (e) {
      isGuest = $cookies.get('browseAsGuest');
    }

    return (isGuest === 'true');
  }
  function getGuestStoreDetail() {
    let guestStore = { 'storeName': null, 'storeId': null };
    try {
      guestStore.storeName = sessionStorage.getItem('guestStoreName');
      guestStore.storeId = sessionStorage.getItem('storeId');
      // if (!guestStore.storeName && !guestStore.storeId) {
      //   guestStore.storeName = $cookies.get('guestStoreName');
      //   guestStore.storeId = $cookies.get('storeId');
      // }
    }
    catch (e) {
      guestStore.storeName = $cookies.get('guestStoreName');
      guestStore.storeId = $cookies.get('storeId');

    }
    return guestStore;
  }
  function addGuestUser(userId, clientIP) {
    if (userId) {
      try {
        sessionStorage.setItem('guestUserId', userId);
        sessionStorage.setItem('guestClientIP', clientIP);
      } catch (e) {
        // No code here
      }
    }
  }
  function getGuestUser() {
    try {
      return {
        guestUserId: sessionStorage.getItem('guestUserId'),
        guestClientIP: sessionStorage.getItem('guestClientIP')
      };
    } catch (e) {
      return {
      };
    }
  }
  function removeGuestUser() {
    sessionStorage.removeItem('guestUserId');
    sessionStorage.removeItem('guestClientIP');
    sessionStorage.removeItem('guestUserDetails');
    sessionStorage.removeItem('curbSideDetails');
  }
  function isMobileOnly() {
    return $timeout(() => {
      if ($window.innerWidth > 543) {
        $state.go('category', { 'storeName': getGuestStoreDetail().storeName });
      }
    });
  }

  function getStoreDetail(storeName) {
    console.log("$stateParams : ", $stateParams);
    if (storeName) {
      return $http.get(`${base().root}${base().storeLoc}/${storeName}`)
        .success(success => {
        if(success){
          try {
              let storeDetailsForInteractionStudio = {
                "store" : {
                  'storeCode' : success.storeCode,
                  'storeName' : success.storeUrlName
                }
            };
            console.log("Sending store info to Interaction studio from scope : ", storeDetailsForInteractionStudio);
            $window.dataLayer = $window.dataLayer || [];
            for (var i = 0; i<$window.dataLayer.length; i++) {
              if ($window.dataLayer[i] && $window.dataLayer[i].store) {
                $window.dataLayer.splice(i, 1);
              }
             }
            $window.dataLayer.push(storeDetailsForInteractionStudio);
            console.log("$window : ", $window);
          } catch (e) {
            console.log("Error at header : ",e);
          }
        }
          $ngRedux.dispatch(authActions.setStoreDetail(success));
        });
    }
    else if($rootScope.storeDetailForInteractionStudio){
          console.log("Sending store info to Interaction studio from rscope : ", $rootScope.storeDetailForInteractionStudio);
            $window.dataLayer = $window.dataLayer || [];
            for (var i = 0; i<$window.dataLayer.length; i++) {
              if ($window.dataLayer[i] && $window.dataLayer[i].store) {
                $window.dataLayer.splice(i, 1);
              }
             }
            $window.dataLayer.push($rootScope.storeDetailForInteractionStudio);
          console.log("$window : ", $window);
    }
    return null;
  }

  function getStore() {
    return $http.get(`${base().root}/store`)
      .success(success => $ngRedux.dispatch(authActions.setStore(success)));
  }

  function getStoreByStoreName(storeUrlName) {
    return $http.get(`${base().root}/franchise/store/`+storeUrlName);
  }

  function registerLogin(data) {
    return $http.post(base().root + base().login, data)
      .success(success => {
        try {
          sessionStorage.setItem('oauth', success.accessToken);
        }
        catch (e) {
          $cookies.put('oauth', success.accessToken);
        }
      });
  }

  function logout(profile) {
    var storeName = profile.store.storeURLName;

    // var logoutObj = {"isEmailUpdate" : profile.emailUpdated };


    return $http.post(base().root + base().logout + '?isEmailUpdate=' + profile.emailUpdated)
      .finally(() => {
        doGuestLogout();
        resetSubscriptionCart();
        removeRemainderSession();
        try {
          sessionStorage.setItem('dummy', 'value');
          sessionStorage.removeItem('oauth');
          sessionStorage.removeItem('addressChangeOption');
          sessionStorage.removeItem('subscriptionLocalState');
          sessionStorage.removeItem('discountCoupon');
          sessionStorage.removeItem('birdbuckCoupon');
          sessionStorage.removeItem('erplyBBDiscount');
          sessionStorage.removeItem('erplyPromotionDiscount');
          sessionStorage.removeItem('guestCart');
          sessionStorage.removeItem('orderNotesSession');
          sessionStorage.removeItem('guestoauth');
          sessionStorage.removeItem('isGuestUserLoggedIn');
          sessionStorage.setItem('activationId', profile.connectionId);
          sessionStorage.setItem('userEmail', profile.email);
          sessionStorage.setItem('isEmailUpdated', profile.emailUpdated);

          // Remove data in cookies
          $cookies.remove('oauth');
          $cookies.remove('addressChangeOption');
          $cookies.remove('subscriptionLocalState');
          $cookies.remove('discountCoupon');
          $cookies.remove('birdbuckCoupon');
          $cookies.remove('guestCart');
          $cookies.remove('activationId');
          $cookies.remove('userEmail');
          $cookies.remove('erplyBBDiscount');
          $cookies.remove('erplyPromotionDiscount');
          $cookies.remove('orderNotesSession');

          this.activationId = this.profile.connectionId;
          this.email = this.profile.email;
        }
        catch (e) {
          $cookies.remove('oauth');
          $cookies.remove('addressChangeOption');
          $cookies.remove('subscriptionLocalState');
          $cookies.remove('discountCoupon');
          $cookies.remove('birdbuckCoupon');
          $cookies.remove('guestCart');
          $cookies.remove('activationId');
          $cookies.remove('userEmail');
          $cookies.remove('erplyBBDiscount');
          $cookies.remove('erplyPromotionDiscount');
          $cookies.remove('orderNotesSession');
          $cookies.remove('guestoauth');
          $cookies.remove('isGuestUserLoggedIn');
        }
        if (profile.emailUpdated) {
          $state.go('signup', {
            storeName: profile.store.storeName
          });
        } else {
          $window.location.href = '/' + storeName;
        }
        // $state.go('login');
      });
  }

  function registerUser(data, isRegisteringFromGuest) {
    return $http.post(base().root + '?isRegisteringFromGuest=' + isRegisteringFromGuest, data);
  }

  function registerStoreUser(data) {
    return $http.post(base().storeCustomer, data);
  }

  function sendEmailToStore(isCustomerMapped, data) {
    return $http.post(`${base().root}/${isCustomerMapped}/verify/mail/sendmailtostore`, data);
  }

  function verifyCustomerEmail(data) {
    return $http.post(base().verify, data);
  }

  function findCustomerInfo(data) {
    return $http.post(base().findCustomer + '?pageFrom=user', data);
  }

  function forgotPassword(data) {
    return $http.post(`${base().root}/password/reset?email=${data.email}`);
  }

  function resetPassword(data) {
    let password = data.password;
    return $http.post(`${base().root}/${data.id}/password/reset?p1=${data.token}`, { password });
  }

  function changePassword(data) {
    return $http.post(`${base().root}/password/change`, data);
  }

  function activate(data) {
    return $http.post(`${base().root}/${data.id}/verify?p1=${data.token}`);
  }

  function oTPactivate(data) {
    return $http.post(`${base().root}/${data.id}/verifyotp?otp=${data.otp}`);
  }

  function activateUser(email) {
    return $http.post(`${base().root}/verify/mail/resend?email=${email}`);
  }

  function resendEmail(data) {
    return $http.post(`${base().root}/${data.id}/verify/mail/resend?email=${data.email}`);
  }

  function getUserProfile() {
    return $http.get(base().root)
      .success(success => {
          $rootScope.storeDetailForInteractionStudio = {
          "store" : {
            "storeCode" : success.customer.store.storeCode,
            "storeName" : success.customer.store.storeURLName
          }
        };
        $ngRedux.dispatch(authActions.setUserProfile(success));
      });
  }

  function getGuestUserProfile() {
    return $http.get(base().root)
      .success(success => $ngRedux.dispatch(authActions.setGuestUserProfile(success)));
  }

  function updateUserProfile(data, id) {
    return $http.put(`${base().root}/${id}`, data)
      .then(success => $ngRedux.dispatch(authActions.setUserProfile(success.data)));
  }

  function saveGuestUser(data) {
    return $http.post(`/guest${base().root}/`, data);
  }

  function getGuestUserById(userId) {
    return $http.get(`/guest${base().root}/${userId}`)
      .then(success => $ngRedux.dispatch(authActions.setUserProfile(success.data)));
  }

  function createGuestCart(data) {
    return $http.post(`/guest${base().root}/cart/create/`, data);
  }

  function showLoginPopUp(msg) {
    $uibModal.open({
      size: 'sm',
      template: '<div class="modal-body p-1-1 login_redirect_modal" id="modal-body" >You have to login/register to ' + msg + '<hr>' +
        '<h6><b><center>Do you want to continue?</center></b></h6>' +
        '</div>' +
        '<div class="modal-footer login_redirect_modal login_redirect_modal_footer bg-color bo-tp-o" >' +
        '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()" >Cancel</button>' +
        '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" ">OK</button>' +
        '</div>',
      controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService',
        function ($rootScope, $scope, $uibModalInstance, $auth) {
          $scope.ok = () => {
            // console.log('ok guestLoginConfirmed');
            $rootScope.$emit('guestLoginConfirmed');
            $uibModalInstance.close();
          };
          $scope.cancel = () => {
            // $auth.removeGuestCart();
            $uibModalInstance.close();
          };
        }
      ]

    });
  }
  function resetSubscriptionCart() {

    try {
      sessionStorage.removeItem('subscribedItems');
      sessionStorage.removeItem('subscribedInfo');
      sessionStorage.removeItem('subscriptionLocalState');
      localStorage.removeItem('deliveryAddress');

      // Remove Cookies
      $cookies.remove('subscribedItems');
      $cookies.remove('subscribedInfo');
      $cookies.remove('subscriptionLocalState');

    }
    catch (e) {
      $cookies.remove('subscribedItems');
      $cookies.remove('subscribedInfo');
      $cookies.remove('subscriptionLocalState');
      localStorage.removeItem('deliveryAddress');

    }
  }
  function addToSubscriptionCart(cartItem, quantity) {

    var subscribedItems = this.getSubscribedItems();

    if (subscribedItems.length > 0) {
      // check for if product is already in subscribed list
      let existingItems = subscribedItems.filter(item => item.item.id === parseInt(cartItem.id));
      if (existingItems.length > 0) {
        existingItems[0].quantity += quantity;
      }
      else {

        var newItem = { 'item': cartItem, 'quantity': quantity };
        subscribedItems.push(newItem);
      }

    } else {
      newItem = { 'item': cartItem, 'quantity': quantity };
      subscribedItems.push(newItem);

    }
    var subscribedItemsString = JSON.stringify(subscribedItems);
    try {
      sessionStorage.setItem('subscribedItems', subscribedItemsString);

    }
    catch (e) {
      $cookies.put('subscribedItems', subscribedItemsString);
    }
  }
  function setSubscribedItems(subscribedItems) {
    var subscribedItemsString = JSON.stringify(subscribedItems);
    try {
      sessionStorage.setItem('subscribedItems', subscribedItemsString);
    } catch (e) {
      $cookies.put('subscribedItems', subscribedItemsString);
    }
  }
  function getSubscribedItems() {
    let subscribedItems = [];
    let subscribedItemsString = '[]';
    try {
      sessionStorage.setItem('dummy', 'value');
      subscribedItemsString = sessionStorage.getItem('subscribedItems');
    }
    catch (e) {
      subscribedItemsString = $cookies.get('subscribedItems');
    }

    subscribedItems = JSON.parse(subscribedItemsString);

    return (subscribedItems) ? subscribedItems : [];
  }
  function setSubscribedInfo(info) {


    var subscribeInfoString = JSON.stringify(info);
    try {
      sessionStorage.setItem('subscribedInfo', subscribeInfoString);

    }
    catch (e) {
      $cookies.put('subscribedInfo', subscribeInfoString);
    }


  }
  function getSubscribedInfo() {
    let subscribedInfo = '';
    let subscribedInfoString = '';
    try {
      sessionStorage.setItem('dummy', 'value');
      subscribedInfoString = sessionStorage.getItem('subscribedInfo');
    }
    catch (e) {
      subscribedInfoString = $cookies.get('subscribedInfo');
    }

    subscribedInfo = JSON.parse(subscribedInfoString);

    return subscribedInfo;
  }

  function cancelSubscriptionfromEmail(data) {
    return $http.post('/api/v1/customer/email/subscription/cancel?requestString=' + data.token);
  }

  function modifySubscripitonfromEmail(data) {
    return $http.post('/api/v1/customer/email/subscription/modifycheck?requestString=' + data.token);
  }
  function subscriptionmodifyId(data) {

    try {
      sessionStorage.setItem('subscriptionmodifyId', JSON.stringify(data));

    }
    catch (e) {
      $cookies.put('subscriptionmodifyId', JSON.stringify(data));
    }
  }

  function getSubscriptionId() {
    let subscriptionmodifyId = null;
    try {
      sessionStorage.setItem('dummy', 'value');
      subscriptionmodifyId = sessionStorage.getItem('subscriptionmodifyId');
    }
    catch (e) {

      subscriptionmodifyId = $cookies.get('subscriptionmodifyId');
    }
    if (subscriptionmodifyId) {
      return JSON.parse(subscriptionmodifyId);
    }
    return subscriptionmodifyId;
  }
  function getSubscriptionLocalState() {
    let subscriptionLocalState = null;
    try {
      sessionStorage.setItem('dummy', 'value');
      subscriptionLocalState = sessionStorage.getItem('subscriptionLocalState');
    }
    catch (e) {

      subscriptionLocalState = $cookies.get('subscriptionLocalState');
    }
    if (subscriptionLocalState) {
      return JSON.parse(subscriptionLocalState);
    }
    return subscriptionLocalState;
  }
  function saveSubscriptionLocalState(localState) {
    try {
      sessionStorage.setItem('subscriptionLocalState', JSON.stringify(localState));

    }
    catch (e) {
      $cookies.put('subscriptionLocalState', JSON.stringify(localState));
    }
  }
  function getCountries() {
    return $http.get(base().root + base().countries.list)
      .then(success => $ngRedux.dispatch(authActions.setCountriesInfo(success.data)));
  }
  function isMobileDevice() {
    // return ( $window.innerWidth < 752 && $window.innerHeight < 752 );
    return ($window.innerWidth < 752);
  }

  function isMobileLandscapeDevice() {
    return ($window.innerWidth < 1000);
  }

  function getStoresbyZipcode(data) {
    return $http.post('/api/v1/customer/storelocator/getnearbystores', data);
  }

  function getAllStores() {
    return $http.get(base().root + base().store.list);
    // .then(success => $ngRedux.dispatch(authActions.setStoresInfo(success.data)));
  }

  function setAllStores() {
    return $http.get(base().root + base().store.list)
      .then(success => $ngRedux.dispatch(authActions.setStoresInfo(success.data)));
  }

  function changeStore(data) {
    return $http.post(base().root + base().store.change, data)
      .success(success => {
        try {
          sessionStorage.setItem('oauth', success.accessToken);
          sessionStorage.removeItem('discountCoupon');
          sessionStorage.removeItem('birdbuckCoupon');
          sessionStorage.removeItem('erplyBBDiscount');
          sessionStorage.removeItem('erplyBBCouponCodes');
          sessionStorage.removeItem('erplyPromotionCodes');
          sessionStorage.removeItem('erplyPromotionDiscount');
          sessionStorage.removeItem('orderNotesSession');
        }
        catch (e) {
          $cookies.put('oauth', success.accessToken);
          $cookies.remove('discountCoupon');
          $cookies.remove('birdbuckCoupon');
          $cookies.remove('erplyBBDiscount');
          $cookies.remove('erplyBBCouponCodes');
          $cookies.remove('erplyPromotionCodes');
          $cookies.remove('erplyPromotionDiscount');
          $cookies.remove('orderNotesSession');
        }
      });
  }

  function getDscImage() {
    return $http.get(base().root + '/getdscimage');
  }

  function getFreeShippingFromStore(storeName) {
    return $http.get(base().root + '/store/freeshipping/' + storeName);
  }

  function validatingPoBoxAddress(postboxaddress, shippingaddress) {
    if (!postboxaddress) {
      if (shippingaddress.match(/(([p]{1}[\.\s]?o{1}[\.\s]?)|(post)|(postoffice)|(post office))[\s]*?(box)/gim)) {
        $uibModal.open({
          size: 'md',
          template: '<div class="modal-header modalheaderbg btn-primary"><h5>PO Box Restriction</h5></div>' +
            '<div class="modal-body" id="modal-body">' +
            // '<span ng-bind-html="'+detailed+'" > </span>'+
            'Sorry, we do not deliver to PO boxes at this time.  Please provide an alternate address.' +
            '</div>' +
            '<div class="modal-footer">' +
            '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
            '</div>',
          controller: ['$scope', '$uibModalInstance',
            function ($scope, $uibModalInstance) {

              $scope.ok = () => {
                $uibModalInstance.close();
              };
            }
          ]
        });
        return true;
      }
    }
    return false;
  }


  function avalaraResolveAddress(userDetail, store) {
    userDetail.store = store;
    return $http.post(base().tax.validate, userDetail);
  }


  function openPopUpForAddressResolve(userDetail, success, callback) {
    console.log("Is this getting called");
    this.userDetail = userDetail;
    this.success = success;
    var $ctrl = this;
    if ($ctrl.userDetail.store.validateAddressType === 'NOT_VALIDATE' || isValidatedAddressSame(userDetail, success)) {
      callback(userDetail);
    } else {
      var modalInstance = $uibModal.open({
        backdrop  : 'static',
        keyboard  : false,
        size: 'md',
        template: '<div class="modal-header modalheaderbg btn-primary"><h5 ng-if="hasValidatedAddress">We found a validated address</h5><h5 ng-if="!hasValidatedAddress">We could not find the address you entered</h5></div>' +
          '<div class="modal-body" id="modal-body">' +
          '<div class="container-fluid">' +
          '<div class="col-md-12 error-text" ng-if="error.message">{{error.message}}</div>' +
          '<div class="row">' +

            `<div class="col-md-4"></div>
                <div class="col-md-6">
                  <div class="col-md-12 mb-4">
                    <h6><strong>Entered Address</strong></h6>
                  </div>
    
                  <div class="col-md-12 mb-4">
                    {{(user.shippingAddressLine1 ? user.shippingAddressLine1.trim() : '')}}
                  </div>
    
                  
                  <div class="col-md-12 mb-4">
                    {{(user.shippingAddressLine2 ? user.shippingAddressLine2.trim() : '')}}
                  </div>
    
                  
                  <div class="col-md-12 mb-4" >
                    {{(user.shippingCity ? user.shippingCity.trim() : '')}},{{(user.shippingState ? user.shippingState.code : '')}}
                  </div>
    
    
                  <div class="col-md-12 mb-4">
                    {{(user.shippingZipCode ? user.shippingZipCode.trim() : '')}}
                  </div>
                </div>
          </div>`
          +

          `<div  class="row" ng-if="isValidAddress && selected.addressLine1.trim()!=null && selected.addressLine1.trim()!=''">
              <hr>
              <div class="col-md-4"></div>
              <div class="col-md-6">
              
              <div class="col-md-12 mb-4" >
                <h6><strong>Validated Address</strong></h6>
              </div>
      
              <div class="col-md-12 mb-4" >
                {{(selected.addressLine1 ? selected.addressLine1.trim() : '')}}
              </div>
      
              <div class="col-md-12 mb-4" >
                {{(selected.addressLine2 ? selected.addressLine2.trim() : '')}}
              </div>
      

              <div class="col-md-12 mb-4" >
                {{(selected.city ? selected.city.trim() : '')}}, {{(selected.state ? selected.state.code : '')}}
              </div>
      

              <div class="col-md-12 mb-4" >
                {{(selected.zip ? selected.zip.trim() : '')}}
              </div>
              </div>
          </div>
  
          <div class="col-md-12" ng-if="!hasValidatedAddress">
          <hr>
          <div class="col-md-5">
            <label style="color: #b58150;font-weight: bold;">Entered Address not Validated with our records</label>
          </div>
          <div class="col-md-7">
            {{summary}}
          </div>
          </div>
          ` +

          '</div>' +
          '</div>' +
          '<div class="modal-footer">' +
          '<button  ng-if="!hasValidatedAddress" class="btn col-md-5" type="button m-l-1" type="button" ng-click="fix()" style="float: left;width: 45%;">I will fix the address</button>' +
          '<button  ng-if="isValidAddress && hasValidatedAddress" class="btn btn-primary m-l-1" type="button" ng-click="submit()" style="float: right;width: 45%;">Use the Validated Address</button>' +
          '<button  ng-if="!hasValidatedAddress" class="btn" type="button m-l-1" ng-click="back()" style="float: right;width: 45%;">Use the Entered Address</button>' +
          '<button  ng-if="hasValidatedAddress" class="btn" type="button m-l-1" ng-click="back()" style="float: left;width: 45%;">Use the Entered Address</button>' +

          '</div>',
        controller: ['$scope', '$state', '$uibModalInstance',
          function ($scope, $state, $uibModalInstance) {
            $scope.error = { message: '' };
            $scope.user = JSON.parse(JSON.stringify($ctrl.userDetail));
            $scope.isValidAddress = false;
            $scope.hasValidatedAddress = false;
            $scope.count = 1;
            if ($ctrl.userDetail.store.validateAddressType === 'BOTH_BILL_SHIP') {
              $scope.count = 2;
            }
            if ($ctrl.success.data.resolutionQuality != null) {
              if ($ctrl.success.data.resolutionQuality === 'Intersection'
                || $ctrl.success.data.resolutionQuality === 'External') {
                $scope.isValidAddress = true;
                $scope.hasValidatedAddress = success.data.isAddressValidated;
                if ($ctrl.userDetail.store.validateAddressType === 'Shipping') {
                  $scope.selected = $ctrl.success.data.shippingAddresstoResolve;
                  if(!success.data.isAddressValidated && $scope.selected.summary!=''){
                    $scope.invalidDetails = $scope.selected.details;
                    $scope.summary = $scope.selected.summary;
                  }
                }
                else if ($ctrl.userDetail.store.validateAddressType === 'Billing') {
                  $scope.selected = $ctrl.success.data.billingAddresstoResolve;
                  if(!success.data.isAddressValidated && $scope.selected.summary!=''){
                    $scope.invalidDetails = $scope.selected.details;
                    $scope.summary = $scope.selected.summary;
                  }
                }
              } else {
                $scope.hasValidatedAddress = success.data.isAddressValidated;
                if ($ctrl.userDetail.store.validateAddressType === 'Shipping') {
                  if ($ctrl.success.data.shippingAddresstoResolve.details != null) {
                    $scope.invalidDetails = $ctrl.success.data.shippingAddresstoResolve.details;
                    $scope.summary = $ctrl.success.data.shippingAddresstoResolve.summary;
                  } else {
                    $scope.invalidDetails = "";
                    $scope.summary = "We haven't find the exact match for given original address";
                  }
                }
                else if ($ctrl.userDetail.store.validateAddressType === 'Billing') {
                  if ($ctrl.success.data.billingAddresstoResolve.details != null) {
                    $scope.invalidDetails = $ctrl.success.data.billingAddresstoResolve.details;
                    $scope.summary = $ctrl.success.data.billingAddresstoResolve.summary;
                  } else {
                    $scope.invalidDetails = "";
                    $scope.summary = "We haven't find the exact match for given original address";
                  }
                }
              }
            } else {
              $scope.hasValidatedAddress = success.data.isAddressValidated;
              $scope.summary = "We haven't find the exact match for given original address";
            }

            $scope.submit = () => {
              // $ctrl.$spinner.show('appSpinner');
              console.log("It calls from submit");
              // $scope.user.isCanceled = false;
              $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
              $scope.user.shippingAddressLine1 = $scope.selected.addressLine1;
              // $scope.user.shippingAddressLine2 = $scope.selected.addressLine1;
              if ($scope.selected.addressLine2 != '') {
                $scope.user.shippingAddressLine2 = $scope.selected.addressLine2;
              }
              $scope.user.shippingCity = $scope.selected.city;
              $scope.user.shippingState.code = $scope.selected.state.code;
              // $scope.user.shippingCountry.code = $scope.selected.country.code;
              $scope.user.shippingZipCode = $scope.selected.zip;
              $uibModalInstance.close($scope.user);

            };
            // $scope.cancel = () => $uibModalInstance.dismiss('cancel');
            $scope.back = () => {
              // $scope.user.isCanceled = false;
              $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
              $uibModalInstance.close($scope.user);
            };
            $scope.fix = () => {
              console.log("In fixing ");
              $scope.user.isCanceled = true;
              $uibModalInstance.close($scope.user);
            };
          }
        ],
        resolve: {
        }
      });
      modalInstance.result.then(function (data) {
        console.log('user clicked ok', data);
        callback(data);
        // return data;
      });
    }
  }

  function isValidatedAddressSame(userDetail, success) {
    if(!success.data.isAddressValidated){
      return false;
    }
    if (success.data.resolutionQuality != null) {
      if (success.data.resolutionQuality === 'Intersection'
        || success.data.resolutionQuality === 'External') {
        if (userDetail.store.validateAddressType === 'NOT_VALIDATE') {
          return true;
        }
        if (userDetail.store.validateAddressType === 'Shipping') {
          if (userDetail.shippingAddressLine1 === success.data.shippingAddresstoResolve.addressLine1 &&
            userDetail.shippingAddressLine2 === success.data.shippingAddresstoResolve.addressLine2 &&
            userDetail.shippingCity === success.data.shippingAddresstoResolve.city &&
            userDetail.shippingCountry.countryCode === success.data.shippingAddresstoResolve.country.countryCode &&
            userDetail.shippingState.code === success.data.shippingAddresstoResolve.state.code &&
            userDetail.shippingZipCode === success.data.shippingAddresstoResolve.zip) {
            return true;
          } else {
            return false;
          }
        }
        else if (userDetail.store.validateAddressType === 'Billing') {
          if (userDetail.billingAddressLine1 === success.data.billingAddresstoResolve.addressLine1 &&
            userDetail.billingAddressLine2 === success.data.billingAddresstoResolve.addressLine2 &&
            userDetail.billingCity === success.data.billingAddresstoResolve.city &&
            userDetail.billingCountry.countryCode === success.data.billingAddresstoResolve.country.countryCode &&
            userDetail.billingState.code === success.data.billingAddresstoResolve.state.code &&
            userDetail.billingZipCode === success.data.billingAddresstoResolve.zip) {
            return true;
          } else {
            return false;
          }
        } else if (userDetail.store.validateAddressType === 'BOTH_BILL_SHIP') {
          var counter = 0;
          if (userDetail.billingAddressLine1 === success.data.billingAddresstoResolve.addressLine1 &&
            userDetail.billingAddressLine2 === success.data.billingAddresstoResolve.addressLine2 &&
            userDetail.billingCity === success.data.billingAddresstoResolve.city &&
            userDetail.billingCountry.countryCode === success.data.billingAddresstoResolve.country.countryCode &&
            userDetail.billingState.code === success.data.billingAddresstoResolve.state.code &&
            userDetail.billingZipCode === success.data.billingAddresstoResolve.zip) {
            counter = counter + 1;
          }
          if (userDetail.shippingAddressLine1 === success.data.shippingAddresstoResolve.addressLine1 &&
            userDetail.shippingAddressLine2 === success.data.shippingAddresstoResolve.addressLine2 &&
            userDetail.shippingCity === success.data.shippingAddresstoResolve.city &&
            userDetail.shippingCountry.countryCode === success.data.shippingAddresstoResolve.country.countryCode &&
            userDetail.shippingState.code === success.data.shippingAddresstoResolve.state.code &&
            userDetail.shippingZipCode === success.data.shippingAddresstoResolve.zip) {
            counter = counter + 1;
          }
          if (counter == 2) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    return false;
  }

  function setAgreedCookie() {
    try {
      var now = new Date();
      var time = now.getTime();
      var expireTime = time + 1000 * 3600 * 24 * 31;
      now.setTime(expireTime);
      console.log("Cookie expiry time : ", now.toUTCString());
      $cookies.put('moove_gdpr_popup_mywbu', true, { 'expires': now.toUTCString() });
    }
    catch (e) {
      $cookies.put('moove_gdpr_popup_mywbu', true);
    }
  }

  function getPwrKeys() {
    return $http.get(`${base().baseRoot}/pwr/keys`)
    .success(success => {
      // console.log("App1 : ",APP.AUTH.AUTH_URL.pwr);
      // console.log("success pwr keys : ",success);
      APP.AUTH.AUTH_URL.pwr.api_key = success.pwr_api_key;
      APP.AUTH.AUTH_URL.pwr.locale = success.pwr_locale;
      APP.AUTH.AUTH_URL.pwr.merchant_group_id = success.pwr_merchant_group_id;
      APP.AUTH.AUTH_URL.pwr.merchant_id = success.pwr_merchant_id;
      // console.log("App2 : ",APP.AUTH.AUTH_URL.pwr);
    });
  }

  function getBBDetails(){
    return $http.get(`${base().baseRoot}/customer/birdbucks/bb-details`);
  }

  function togglePassword(passwordIdTag,togglei) {
    var x = document.getElementById(passwordIdTag);
    var y = document.getElementById(togglei);
      console.log("Password tag ", x);
    if (x.type === "password") {
      x.type = "text";
      y.classList.remove('fa-eye-slash');
      y.classList.add('fa-eye');
    } else {
      x.type = "password";
      y.classList.remove('fa-eye');
      y.classList.add('fa-eye-slash');
    }
  }

  function removeRemainderSession() {
    try {
      sessionStorage.removeItem(baseOrderConstants().SESSION_STORAGE.OUT_OF_STOCK_REMAINDERS);
      // $cookies.remove(baseOrderConstants().SESSION_STORAGE.OUT_OF_STOCK_REMAINDERS);
    }
    catch (e) {
      // $cookies.remove(baseOrderConstants().SESSION_STORAGE.OUT_OF_STOCK_REMAINDERS);
    }
  }

  function getBaseShippingCharge() {
    return $http.get('/api/v1/customer/shipping/base/charge');
  }

  function printCustomerGenericLogs(dataValue) {

    var stringData = {};
    stringData.config = {};
    if(dataValue && dataValue.config) {
      stringData.config.data = JSON.stringify(dataValue.config.data);
      stringData.config.headers = JSON.stringify(dataValue.config.headers);
      stringData.config.method = JSON.stringify(dataValue.config.method);
      stringData.config.url = JSON.stringify(dataValue.config.url);
    }
    if(dataValue && dataValue.data) {
      stringData.data = {};
      stringData.data.diagnostic =  JSON.stringify(dataValue.data.diagnostic);
      stringData.data.message =  JSON.stringify(dataValue.data.message);
      stringData.data.httpCode =  JSON.stringify(dataValue.data.httpCode);
    }
    return $http.post('/api/v1/customer/print/logs', stringData);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/service.js